import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Paneset } from '@folio/stripes-components';
import useURLParams from '../hooks/useURLParams copy';
import CopycatQueryBuilder from './CopycatQueryBuilder/CopycatQueryBuilder';
import CopycatResultsPreview from './CopycatResultsPreview/CopycatResultsPreview';
import ViewSourceModal from '../shared/ViewSourceModal/ViewSourceModal';
import QuickMarcEditModal from '../shared/QuickMarcEditModal/QuickMarcEditModal';
import ImportSingleRecordModal from '../shared/ImportSingleRecord/ImportSingleRecordModal';
import useCopycatSources from '../hooks/useCopycatSources';
import CopycatViewRecord from './CopycatRecord/CopycatViewRecord/CopycatViewRecord';

function CopyCatSearch(props) {
  const [resultSets, setResultSets] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showQueryPane, setShowQueryPane] = useState(true);
  const [showRecordPane, setShowRecordPane] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [selectedItems, setSelectedItems] = useState([]);
  const [importedList, setImportedList] = useState([]);

  const [openViewSourceModal, setOpenViewSourceModal] = useState(false);
  const [openImportRecordModal, setOpenImportRecordModal] = useState(false);
  const [showQuickMarcEditModal, setShowQuickMarcEditModal] = useState(false);

  const [querySources, setQuerySources] = useURLParams(
    'sources',
    ['Koha Demo', 'Library of Congress'],
    'array',
  );
  const [currentPage, setCurrentPage] = useURLParams('page', 1, 'number');
  const [pageSize, setPageSize] = useURLParams('size', 50, 'number');

  const { sourcesList } = useCopycatSources();

  return (
    <>
      <Paneset>
        <CopycatQueryBuilder
          {...props}
          showQueryPane={showQueryPane}
          setShowQueryPane={setShowQueryPane}
          sourcesList={sourcesList}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          setResultSets={setResultSets}
          setIsLoading={setIsLoading}
          setError={setError}
          isLoading={isLoading}
          querySources={querySources}
          setQuerySources={setQuerySources}
          pageSize={pageSize}
          setPageSize={setPageSize}
        />
        <CopycatResultsPreview
          showQueryPane={showQueryPane}
          setShowQueryPane={setShowQueryPane}
          searchResponse={{ resultSets, error, isLoading }}
          selectedSources={querySources}
          sourcesList={sourcesList}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          pageSize={pageSize}
          setShowRecordPane={setShowRecordPane}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          setOpenViewSourceModal={setOpenViewSourceModal}
          importedList={importedList}
        />
        <CopycatViewRecord
          showRecordPane={showRecordPane}
          onClose={setShowRecordPane}
          selectedItem={selectedItem}
          setOpenViewSourceModal={setOpenViewSourceModal}
          setOpenImportRecordModal={setOpenImportRecordModal}
          setShowQuickMarcEditModal={setShowQuickMarcEditModal}
        />
      </Paneset>
      <ViewSourceModal
        open={openViewSourceModal}
        onClose={() => setOpenViewSourceModal(false)}
        itemToView={selectedItem}
        selectedItems={selectedItems}
      />
      <QuickMarcEditModal
        open={showQuickMarcEditModal}
        onClose={() => setShowQuickMarcEditModal(false)}
        itemToEdit={selectedItem}
      />
      <ImportSingleRecordModal
        open={openImportRecordModal}
        onClose={() => setOpenImportRecordModal(false)}
        itemToImport={selectedItem}
        sourcesList={sourcesList}
        importedList={importedList}
        setImportedList={setImportedList}
      />
    </>
  );
}

CopyCatSearch.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
  }).isRequired,
};

export default CopyCatSearch;
